import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { hasPrivilege } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import { selectedSome } from '../../stores/tables/selectors';
import TableToolbar from '../table/TableToolbar';

import ActivateUsersAction from './actions/ActivateUsersAction';
import AssignUsersApplicationsAction from './actions/AssignUsersApplicationsAction';
import AssignUsersGroupsAction from './actions/AssignUsersGroupsAction';
import AssignUsersWorkspaceAction from './actions/AssignUsersWorkspaceAction';
import CopyUserAction from './actions/CopyUserAction';
import CSVImportAction from './actions/CSVImportAction';
import DeactivateUsersAction from './actions/DeactivateUsersAction';
import DeleteUsersAction from './actions/DeleteUsersAction';
import ExportReportAction from './actions/ExportReportAction';
import LoginAsAction from './actions/LoginAsAction';
import SendMigrateAccountMailAction from './actions/SendMigrateAccountMailAction';
import SendMigratePasswordMailAction from './actions/SendMigratePasswordMailAction';
import SendNewUserMailAction from './actions/SendNewUserMailAction';
import SendResetPasswordMailAction from './actions/SendResetPasswordMailAction';
import SynchronizeUsersAction from './actions/SynchronizeUsersAction';
import CreateUsersApplicationKeyAction from './actions/CreateUsersApplicationKeyAction';
import UpdateUsersAction from './actions/UpdateUsersAction';
import SendVerifyEmailMailAction from './actions/SendVerifyEmailMailAction';

interface Props extends LocalizeContextProps, RouteComponentProps {
    selectedSome: boolean;
    hasPrivilege: (privileges: string[]) => boolean;
}

interface State {
    showActions: boolean;
}

class UsersToolbar extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showActions: false
        };
    }

    public render() {
        const t = this.props.translate;
        return (
            <TableToolbar>
                {this.renderActionMenu()}
                <ExportReportAction />
                <CSVImportAction />
                <Button
                    color="primary"
                    className="action-btn"
                    onClick={() => {
                        this.props.history.push(`/users/new`);
                    }}
                >
                    <FontAwesomeIcon
                        className="mr-4"
                        icon={['fal', 'plus']}
                    />
                    {t('users.button.add')}
                </Button>
            </TableToolbar>
        );
    }

    private renderActionMenu = () => {
        const t = this.props.translate;
        const menuItems = _.compact(this.renderActions());
        
        if (menuItems.length > 0) {
            return (
                <ButtonDropdown
                    id="action-buttons"
                    className="action-btn"
                    color="default"
                    title={t('users.button.actions') as string}
                    isOpen={this.state.showActions}
                    toggle={() => { this.setState({ showActions: !this.state.showActions }); }}
                    style={{ marginRight: '10px' }}
                >
                    <DropdownToggle caret={true}>
                        {t('users.button.actions')}
                    </DropdownToggle>
                    <DropdownMenu persist={true}>
                        {menuItems}
                    </DropdownMenu>
                </ButtonDropdown>
            );
        } else {
            return <div />;
        }
    }

    private renderActions = () => {
        const t = this.props.translate;
        if (this.props.selectedSome) {
            return (
                [
                    <LoginAsAction key={0} />,
                    <CopyUserAction key={12} />, // TODO
                    <AssignUsersWorkspaceAction key={1} />, // TODO
                    <AssignUsersGroupsAction key={2} />, // TODO
                    <AssignUsersApplicationsAction key={3} />, // TODO
                    <DeleteUsersAction key={4} />, // TODO
                    <SendNewUserMailAction key={5} />, // TODO
                    <SendResetPasswordMailAction key={6} />, // TODO
                    <SendVerifyEmailMailAction key={7} />,
                    <SendMigrateAccountMailAction key={8} />, // TODO
                    <SendMigratePasswordMailAction key={9} />, // TODO
                    <SynchronizeUsersAction key={10} />, // TODO
                    <ActivateUsersAction key={11} />, // TODO
                    <DeactivateUsersAction key={12} />, // TODO
                    <CreateUsersApplicationKeyAction key={13} />,
                    <UpdateUsersAction key={14} />
                ]
            );

        } else {
            return [];
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selectedSome: selectedSome(state, 'users'),
});

export default connect(mapStateToProps)(withLocalize(withRouter(UsersToolbar)));